<ui-toolbar-top [title]="'Orders'" [backVisible]="true"></ui-toolbar-top>

<ui-user-orders></ui-user-orders>